"use client";

import {
  IoAlertCircle,
  IoCheckmarkCircle,
  IoCloseCircle,
  IoInformationCircle,
  IoReload,
} from "react-icons/io5";
import { Toaster as Sonner } from "sonner";
import classes from "./Toaster.module.css";

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme={"light"}
      className={classes.toaster}
      icons={{
        success: <IoCheckmarkCircle className="main-color" />,
        info: <IoInformationCircle color="#40b3bf" />,
        warning: <IoAlertCircle color="#bfbf40" />,
        error: <IoCloseCircle color="#bf4040" />,
        loading: <IoReload className={`${classes.loadingIcon} text-text`} />,
      }}
      toastOptions={{
        classNames: {
          toast: classes.toast,
          description: classes.description,
          icon: classes.icon,
          actionButton: classes.actionButton,
          cancelButton: classes.cancelButton,
        },
      }}
      position="top-right"
      dismissable={true}
      closeButton={true}
      {...props}
    />
  );
};

export { Toaster };
